<form [formGroup]="formGroup" [ngClass]="{'hv-daten-hidden': !showGroup}" appPropagateSubmit [parentFormGroupDirective]="parentFormGroupDirective" autocomplete="off">
  <div class="infotext" *ngIf="showProduktBuendel; else infotextTemplate">
      <p>Berechnen Sie Ihr individuelles Angebot für eine HDI Haushalts- und Eigenheimversicherung. Das Wichtigste im Überblick:</p>
      <p>Informationsblatt (<a href='{{ getProduktLink(2) }}' target="_blank">Haushaltsversicherung</a> / <a href='{{ getProduktLink(1) }}' target="_blank">Eigenheimversicherung</a>) oder Deckungsumfang (<a href='{{ getDeckungsUmfangLink(2) }}' target="_blank">Haushaltsversicherung </a>/ <a href='{{ getDeckungsUmfangLink(1) }}' target="_blank">Eigenheimversicherung</a>) herunterladen.<span *ngIf="!expertMode"> Informationen darüber, wie wir Ihre personenbezogenen Daten verarbeiten, finden Sie in unseren <a href='https://www.hdi.at/datenschutz/' target="_blank">Datenschutzhinweisen</a>.</span></p>
      <br>
      <p>Erforderliche Felder sind mit * markiert.</p>
      <p>In Kombination mit einer Eigenheimversicherung erhalten Sie <b class="standard-text-bold">10% Rabatt</b> auf Ihre Haushaltsprämie.</p>
  </div>
  <ng-template #infotextTemplate>
    <div class="infotext" *ngIf="(!expertMode && translateService.get('INFOTEXT', { produktName: getProduktName(), produktLink: getProduktLink(), deckungsUmfangLink: getDeckungsUmfangLink() }) | async) as res" [innerHTML]="res"></div>
    <div class="infotext" *ngIf="(expertMode && translateService.get('INFOTEXTEXPERT', { produktName: getProduktName(), produktLink: getProduktLink(), deckungsUmfangLink: getDeckungsUmfangLink() }) | async) as res" [innerHTML]="res"></div>
  </ng-template>
  <div class="hv-daten-form-container">
    <app-vertragsbeginn-laufzeit [parentFormGroupDirective]="parentFormGroupDirective" [formGroup]="vertragsbeginnLaufzeit" (calculateRatePendingEvent)="onCalculateRatePending()"></app-vertragsbeginn-laufzeit>
    <h6 class="hv-header-bold" *ngIf="showProduktEigenheim">Hauptgebäude</h6>
    <div class="hv-daten-split-container" id="daten-hauptgebaeude">
      <div class="hv-daten-split-left">
        <div class="input_radio" *ngIf="showProduktEigenheim">
          <div class="text_info">
            <app-label [control]="bauweise" for="bauweise">Bauweise</app-label>
            <div class="info">
              <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get('BAUWEISEINFO') | async) as res" (click)="popupService.openInfoPopup(res)">
              </div>
            </div>
          </div>
          <mat-radio-group id="bauweise" formControlName="bauweise">
            <mat-radio-button value="3">Massiv hart</mat-radio-button>
            <mat-radio-button value="1">Holzbauweise</mat-radio-button>
            <br>
            <mat-radio-button value="2">Gemischt</mat-radio-button>
            <mat-radio-button value="4">Niedrigenergiehaus</mat-radio-button>
          </mat-radio-group>
          <mat-error *ngIf="bauweise.hasError('required') && parentFormGroupDirective.submitted">{{
            'SELECTREQUIRED' | translate }}</mat-error>
        </div>
        <app-bewilligungsjahr-haus [parentFormGroupDirective]="parentFormGroupDirective" [formGroup]="bewilligungsjahrHaus" [isWohnung]="isWohnung" (calculateRatePendingEvent)="onCalculateRatePending()"></app-bewilligungsjahr-haus>
        <div class="input_radio" *ngIf="showProduktEigenheim">
          <app-label [control]="leitungswasserschaedenAusschliessen" for="leitungswasserschaedenAusschliessen">Deckungsumfang Eigenheimversicherung</app-label>
          <mat-radio-group id="leitungswasserschaedenAusschliessen" formControlName="leitungswasserschaedenAusschliessen">
            <mat-radio-button value="nein">Vollschutz (kompletter Deckungsumfang laut Bedingungen)</mat-radio-button>
            <mat-radio-button value="ja">Standardschutz (kompletter Deckungsumfang laut Bedingungen abzüglich Leitungswasserschäden)</mat-radio-button>
          </mat-radio-group>
          <mat-error *ngIf="leitungswasserschaedenAusschliessen.hasError('required') && parentFormGroupDirective.submitted">{{
            'SELECTREQUIRED' | translate }}</mat-error>
          <div class="label-infotext mindestpraemie-infotext">Bei Auswahl „Standardschutz“ sind die Zusatzpakete Pool und Heizung in weiterer Folge nicht auswählbar.</div>
        </div>
        <div class="input_radio" *ngIf="showProduktHaushalt">
          <div class="text_info">
            <app-label [control]="einrichtung" for="einrichtung">Ausstattungsvariante</app-label>
            <div class="info">
              <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get('EINRICHTUNGINFO') | async) as res" (click)="popupService.openInfoPopup(res)"></div>
            </div>
          </div>
          <mat-radio-group id="einrichtung" formControlName="einrichtung">
            <mat-radio-button *ngFor="let einrichtung of Einrichtungen| keyvalue" [value]="einrichtung.key.toString()">{{ einrichtung.value}}</mat-radio-button>
          </mat-radio-group>
          <mat-error *ngIf="einrichtung.hasError('required') && parentFormGroupDirective.submitted">{{
            'SELECTREQUIRED' | translate }}</mat-error>
        </div>
        <app-gebaeude-hochwasserzone [parentFormGroupDirective]="parentFormGroupDirective" [formGroup]="gebaeudeHochwasserzone" (calculateRatePendingEvent)="onCalculateRatePending()" (loadHvPaketePendingEvent)="onLoadHvPaketePendingEvent()"></app-gebaeude-hochwasserzone>
        <div class="input_radio" *ngIf="showProduktHaushalt">
          <app-label [control]="staendigBewohnt" for="staendigBewohnt">Das Gebäude wird von mindestens einer Person 180 Tage im Jahr - auch nachts - bewohnt</app-label>
          <mat-radio-group id="staendigBewohnt" formControlName="staendigBewohnt">
            <mat-radio-button value="ja">Ja</mat-radio-button>
            <mat-radio-button value="nein">Nein</mat-radio-button>
          </mat-radio-group>
          <mat-error *ngIf="staendigBewohnt.hasError('required') && parentFormGroupDirective.submitted">{{
            'SELECTREQUIRED' | translate }}</mat-error>
        </div>
        <div *ngIf="staendigBewohnt.hasError('invalid') && (showProduktHaushalt && !showGebaeudeartWohnung && !showProduktBuendel)">
          <div class="text_info">
            <label class="red-error-text-circle">Wenn das Gebäude weniger als 180 Tage im Jahr bewohnt wird, stellt dies ein anfragepflichtiges <b>Sonderrisiko</b> dar. <span [innerHTML]="(expertMode? translateService.get('SPEZIELLEANFRAGEEXPERT')  : translateService.get('SPEZIELLEANFRAGE'))|async"></span>
              <div class="info">
                <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get('SONDERRISIKOBEWOHNTINFO') | async) as res" (click)="popupService.openInfoPopup(res)"></div>
              </div>
            </label>
          </div>
        </div>
      </div>
      <div class="hv-daten-split-right-dynamic" [hidden]="!(showProduktEigenheim || (showProduktHaushalt && !showGebaeudeartWohnung))">
        <app-verbaute-flaeche [parentFormGroupDirective]="parentFormGroupDirective" [formGroup]="verbauteFlaeche" [showGroup]="showProduktEigenheim || (showProduktHaushalt && !showGebaeudeartWohnung)" [produktart]="produktart" [gebaeudeart]="gebaeudeart" (calculateRatePendingEvent)="onCalculateRatePending()"></app-verbaute-flaeche>
      </div>
      <div class="hv-daten-split-right" *ngIf="showGebaeudeartWohnung">
        <div class="input">
          <div class="text_info">
            <app-label [control]="wohnnutzFlaecheQm" class="input__label" for="wohnnutzFlaecheQm">Wohnfläche in m²</app-label>
            <div class="info">
              <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get(expertMode ? 'WOHNFLAECHEQMINFOEXPERT' : 'WOHNFLAECHEQMINFO') | async) as res" (click)="popupService.openInfoPopup(res)"></div>
            </div>
          </div>
          <mat-form-field>
            <input matInput id="wohnnutzFlaecheQm" [maxlength]="3" formControlName="wohnnutzFlaecheQm">
            <mat-error *ngIf="wohnnutzFlaecheQm.hasError('required')">{{
              'INPUTREQUIRED' | translate }}</mat-error>
            <mat-error *ngIf="wohnnutzFlaecheQm.hasError('pattern')">{{
              'INPUTINVALID' | translate }}</mat-error>
            <mat-error *ngIf="!wohnnutzFlaecheQm.hasError('pattern') && wohnnutzFlaecheQm.hasError('min')">{{
              'MINVALUE' | translate:{'value': wohnnutzFlaecheQm.errors.min.min} }}</mat-error>
            <mat-error *ngIf="!wohnnutzFlaecheQm.hasError('pattern') && wohnnutzFlaecheQm.hasError('max')">{{
              'MAXVALUE' | translate:{'value': wohnnutzFlaecheQm.errors.max.max} }}</mat-error>
          </mat-form-field>
        </div>
        <div class="input_radio">
          <app-label [control]="wohnungGarten" for="wohnungGarten">Wohnung mit Garten</app-label>
          <mat-radio-group id="wohnungGarten" formControlName="wohnungGarten">
            <mat-radio-button value="ja">Ja</mat-radio-button>
            <mat-radio-button value="nein">Nein</mat-radio-button>
          </mat-radio-group>
          <mat-error *ngIf="wohnungGarten.hasError('required') && parentFormGroupDirective.submitted">{{
            'SELECTREQUIRED' | translate }}</mat-error>
        </div>
      </div>
      <div *ngIf="staendigBewohnt.hasError('invalid') && (showProduktHaushalt && (showGebaeudeartWohnung || showProduktBuendel))">
        <div class="text_info">
          <label class="red-error-text-circle">Wenn das Gebäude weniger als 180 Tage im Jahr bewohnt wird, stellt dies ein anfragepflichtiges <b>Sonderrisiko</b> dar. <span [innerHTML]="(expertMode? translateService.get('SPEZIELLEANFRAGEEXPERT')  : translateService.get('SPEZIELLEANFRAGE'))|async"></span>
            <div class="info">
              <div class="info_trigger icon--before icon--info" *ngIf="(translateService.get('SONDERRISIKOBEWOHNTINFO') | async) as res" (click)="popupService.openInfoPopup(res)"></div>
            </div>
          </label>
        </div>
      </div>
      <div class="hv-daten-teaser-container" [ngClass]="{'hv-daten-teaser-buffer': showProduktHaushalt && !showGebaeudeartWohnung && !showProduktBuendel}">
        <div class="input_radio" *ngIf="showProduktHaushalt">
          <div class="teaser">
            <div class="hv-daten-teaser-title">Top-Haushalt Deckungserweiterung</div>
            <a class="hv-daten-teaser-subtitle" href="https://www.hdi.at/produkte/wohnen/haushaltsversicherung-top/" target="_blank">mehr Informationen</a>
            <div class="hv-daten-teaser-intro">Die Deckungserweiterung „Top-Haushalt“ bietet unter anderem folgende Zusatzleistungen:</div>
            <ul>
              <li>100% grobe Fahrlässigkeit</li>
              <li>Kühlgutversicherung bis zu <span class="custom_currency">€ 500,-</span></li>
              <li>Schäden durch indirekten Blitzschlag an elektrischen Geräten und Einrichtungen werden zum Neuwert ersetzt</li>
              <li>Verglasungen von Küchengeräten werden bis zu <span class="custom_currency">€ 1.000,-</span> ersetzt</li>
              <li>Markisen an Gebäuden gegen Feuer und Sturm bis zu <span class="custom_currency">€ 2.500,-</span></li>
              <li>Erhöhte Limits für Sengschäden, Verpuffungsschäden und Implosion</li>
              <li>Mitversicherung von Kosten, beispielsweise Aufräum- und Abbruchkosten, Feuerlöschkosten, Demontage-, Remontage-, Reinigungs- und Entsorgungskosten bis zu 20% der Versicherungssumme.</li>
            </ul>
          </div>
          <app-label [control]="topHaushalt" for="topHaushalt">Top-Haushalt</app-label>
          <mat-radio-group id="topHaushalt" formControlName="topHaushalt">
            <mat-radio-button value="ja">Ja</mat-radio-button>
            <mat-radio-button value="nein">Nein</mat-radio-button>
          </mat-radio-group>
          <mat-error *ngIf="topHaushalt.hasError('required') && parentFormGroupDirective.submitted">{{
            'SELECTREQUIRED' | translate }}</mat-error>
        </div>
        <div class="input_radio" *ngIf="showProduktEigenheim">
          <div class="teaser hv-daten-eigenheim-teaser">
            <div class="hv-daten-teaser-title">Top-Eigenheim Deckungserweiterung</div>
            <a class="hv-daten-teaser-subtitle" href="https://www.hdi.at/produkte/wohnen/eigenheimversicherung-top/" target="_blank">mehr Informationen</a>
            <div class="hv-daten-teaser-intro">Die Deckungserweiterung „Top-Eigenheim“ bietet unter anderem folgende Zusatzleistungen:</div>
            <ul>
              <li>100% grobe Fahrlässigkeit</li>
              <li>Schäden durch indirekten Blitzschlag an elektrischen Geräten und Einrichtungen werden zum Neuwert ersetzt</li>
              <li>Allmählichkeitsschäden durch Austritt von Leitungswasser bis <span class="custom_currency">€ 2.500,-</span></li>
              <li>Optische Schäden nach einem Hagelschlag bis zu <span class="custom_currency">€ 5.000,-</span></li>
              <li>Planungs- und Architektenkosten bis zu <span class="custom_currency">€ 7.500,-</span></li>
              <li>Wasserverlust bis zu <span class="custom_currency">€ 2.000,-</span></li>
              <li>Mitversicherung von Kosten, beispielsweise Aufräum- und Abbruchkosten, Feuerlöschkosten, Demontage-, Remontage-, Reinigungs- und Entsorgungskosten bis zu 20% der Versicherungssumme.</li>
            </ul>
          </div>
          <app-label [control]="topEigenheim" for="topEigenheim">Top-Eigenheim</app-label>
          <mat-radio-group id="topEigenheim" formControlName="topEigenheim">
            <mat-radio-button value="ja">Ja</mat-radio-button>
            <mat-radio-button value="nein">Nein</mat-radio-button>
          </mat-radio-group>
          <mat-error *ngIf="topEigenheim.hasError('required') && parentFormGroupDirective.submitted">{{
            'SELECTREQUIRED' | translate }}</mat-error>
        </div>
      </div>
    </div>
    <div class="hv-daten-nebengebaeude-container" *ngIf="showProduktEigenheim">
      <h6 class="hv-header-bold" id="daten-nebengebaeude">Nebengebäude</h6>
      <div>
        <div class="input_radio">
          <app-label [control]="nebengebaeude" for="nebengebaeude">Nebengebäude vorhanden</app-label>
          <mat-radio-group id="nebengebaeude" formControlName="nebengebaeude">
            <mat-radio-button value="ja">Ja</mat-radio-button>
            <mat-radio-button value="nein">Nein</mat-radio-button>
          </mat-radio-group>
          <mat-error *ngIf="nebengebaeude.hasError('required') && parentFormGroupDirective.submitted">{{
            'SELECTREQUIRED' | translate }}</mat-error>
        </div>
      </div>
      <div>
        <div *ngIf="showAnzahlNebengebaeude">
          <p class="smallprint-gray">Beim ersten Nebengebäude sind € 15.000,- Versicherungssumme prämienfrei inkludiert.</p>
          <app-label [control]="anzahlNebengebaeude" for="nebengebaeude">Anzahl Nebengebäude:</app-label>
          <mat-form-field class="hv-daten-nebengebaeude-anzahl-select">
            <mat-select id="anzahlNebengebaeude" formControlName="anzahlNebengebaeude">
              <mat-option value="1">1</mat-option>
              <mat-option value="2">2</mat-option>
              <mat-option value="3">3</mat-option>
              <mat-option value="4">4</mat-option>
              <mat-option value="5">5</mat-option>
            </mat-select>
          </mat-form-field>
          <mat-error *ngIf="anzahlNebengebaeude.hasError('required') && parentFormGroupDirective.submitted">{{
            'SELECTREQUIRED' | translate }}</mat-error>
        </div>
      </div>
      <div class="hv-sub-list-container" formArrayName="nebengebaeudeGroups">
        <div class="hv-sub-list-item-container" *ngFor="let nebengebaeudeGroup of nebengebaeudeGroups.controls; index as i">
          <div class="hv-sub-list-item-index standard-text-bold">
            {{ i+1 }}
          </div>
          <app-nebengebaeude class="hv-sub-list-item-content" [parentFormGroupDirective]="parentFormGroupDirective" [formGroup]="nebengebaeudeGroup" [showLeitungswasser]="showLeitungswasser" [showTopEigenheim]="showTopEigenheim" [index]="i" (calculateRatePendingEvent)="onCalculateRatePending()">
          </app-nebengebaeude>
        </div>
      </div>
    </div>
  </div>
</form>
